import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import i18next from 'i18next';

import { withRouter } from 'react-router-dom';
import { getShareViaEmailSelector } from 'common/selectors/index';
import { getSharePathSelector } from '../selectors';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { ShareButton } from '../share-button';

const EmailButton = ({ isVisible, onClick }) => (
  <ShareButton hidden={!isVisible} dataE2e="email" onClick={onClick} icon={faEnvelope} label={i18next.t('email')} />
);

const mapStateToProps = (state, props) => {
  const params = props.match && props.match.params;
  const isShareViaEmailEnabled = !!getShareViaEmailSelector(state);
  const path = encodeURIComponent(getSharePathSelector(params)(state));

  return {
    path,
    isShareViaEmailEnabled,
  };
};

const combineProps = ({ path, isShareViaEmailEnabled }, _, { t }) => {
  return {
    isVisible: isShareViaEmailEnabled,
    onClick: () => {
      window.location = 'mailto:?body=' + path;
    },
    t,
  };
};

export const EmailButtonDecorated = compose(withRouter, connect(mapStateToProps, null, combineProps))(EmailButton);
